import { ActionButtonProps, Box, Form, ModBox, Spacer } from '@jfs/ui-new'
import { useRoute } from '@react-navigation/native'
import { useEffect, useRef, useState } from 'react'
import { ScrollView, ViewProps, Platform } from 'react-native'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { logEvent } from '../../../../util/util'
import { RenderActionButtons } from './ActionButton'
import { formData } from './FormData'
import { parseFormData } from './FormDataParser'
import { ModelUserAdded } from './ModelUserAdded'

export type ItemState = {
  id: number
  state: boolean
  readOnly?: boolean
}

const AddUser = ({ navigation }: any) => {
  const {
    getAcessRightData,
    jfsUserId,
    mid,
    addEditUserApi,
    refreshUserManagementTable,
    refreshTable,
    merchants,
    selectedMid,
  } = useStores((store) => ({
    getAcessRightData: store.userManagement.getAcessRightData,
    jfsUserId: store.user.session.getJfsUserId(),
    mid: store.user.selectedMid,
    addEditUserApi: store.userManagement.addEditUserApi,
    refreshUserManagementTable: store.userManagement.refreshUserManagementTable,
    refreshTable: store.userManagement.refreshTable,
    selectedMid: store.user.selectedMid,
    merchants: store.user.merchants,
  }))

  const editData: any = useRoute()?.params
  const [dropdownValue, updateDropdownValue] = useState('Select user role')
  const [isEditScreen, updateIsEditScreen] = useState(false)
  const [addEmailEnabled, setAddEmailEnabled] = useState(false)
  const [isCurrentFormValid, setIsCurrentFormValid] = useState(false)
  const [accessRightsData, setAccessData] = useState(getAcessRightData(undefined))
  const formRef = useRef(null)
  const buttonRef = useRef<ActionButtonProps>()
  const [showUserModel, setShowUserModel] = useState(false)
  const [addEditUser, addEditUserHandler = { data: [], state: undefined }] = useLazyApiData(addEditUserApi)

  useEffect(() => {
    if (addEditUserHandler.state === 'fulfilled') {
      setShowUserModel(true)
      //To update store for refreshing the table in previous screen, wont use state as it will lead to un necessary re render.
      refreshUserManagementTable(!refreshTable)
    }
    //NOTE: We don't need dependency of refreshTable because it will lead to re call of this use effect hook because store will change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addEditUserHandler.state, refreshUserManagementTable])

  const onDropdownValueChange = (value: string) => {
    // console.log('value', value)
    if (value === 'Admin') {
      // console.log('pre select all', checkedArray)
      onSelectAllChange(false, value)
    } else if (value === 'Cashier' || value === 'Other') {
      const newArray: ItemState[] = checkedArray?.map((item: ItemState) => ({ ...item }))
      // debugger
      newArray?.map((item: ItemState) => {
        const updated = { ...item, state: true, readOnly: false }
        return updated
      })

      const newData = accessRightsData.map((item: any, index: number) => {
        if (item.type === 'User Management' && value === 'Cashier') {
          newArray[index].state = false
          newArray[index].readOnly = true
          item.data.map((childItem: any) => {
            childItem.isChecked = false
            childItem.readOnly = true
            return childItem
          })
        } else {
          newArray[index].state = true
          // select all
          item.data.map((childItem: any) => {
            childItem.isChecked = true
            childItem.readOnly = false
            return childItem
          })
        }
        return item
      })
      // debugger
      setCheckedArray(newArray)
      setAccessData(newData)
    } else {
      onSelectAllChange(true, value)
    }
    updateDropdownValue(value)
  }

  const getFormData = (): any[] => {
    const initialFormData = [
      ...formData({
        dropdownValue: dropdownValue,
        onDropdownValueChange: onDropdownValueChange,
        accessRightsData: accessRightsData ?? [],
        isEditScreen: isEditScreen,
        onSelectAllChange: onSelectAllChange,
        expandView: false,
        checkedArray: checkedArray,
        updateCheckedArray: updateCheckedArray,
        addEmailEnabled: addEmailEnabled,
        onPressAddEmail: setAddEmailEnabled,
      }),
    ]
    return initialFormData
  }

  const defaultCheckedArray: ItemState[] = accessRightsData?.map((_item: any, index: number) => ({
    id: index,
    state: true,
    readOnly: true,
  }))
  const [checkedArray, setCheckedArray] = useState<ItemState[]>(defaultCheckedArray)

  const updateAllCheckedArray = (value: any, role: string) => {
    const newArray: ItemState[] = checkedArray?.map((item: ItemState) => ({ ...item }))
    newArray.forEach((item: ItemState) => {
      item.state = value
      item.readOnly = false
    })

    // accessRightsData.map((item: any, index: number) => {
    //   if (item.type === 'User Management' && role === 'Other') {
    //     newArray[index].state = value
    //     newArray[index].readOnly = true
    //   }
    // })

    setCheckedArray(newArray)
  }
  const updateCheckedArray = (index: number, value: any) => {
    checkedArray[index].state = value
  }
  const onSelectAllChange = (value: boolean, role: string) => {
    const newData = accessRightsData.map((item: any) => {
      item.data.map((childItem: any) => {
        // permissions can't be updated for admin
        if (role === 'Admin') {
          childItem.isChecked = true
          childItem.readOnly = true
        } else if (role === 'Cashier') {
          childItem.isChecked = item.type === 'User Management' ? false : !value
          childItem.readOnly = true
        } else {
          // permissions can be updated for others
          childItem.isChecked = !value
          childItem.readOnly = false
        }
        return childItem
      })

      return item
    })
    updateAllCheckedArray(!value, role)
    setAccessData(newData)
  }
  console.log('htag addEditUser ', addEditUserHandler)
  const onSubmitPress = () => {
    console.log('htag onSubmitPress ')
    const previousFormData = { ...editData?.user, accessRightsData: accessRightsData ?? [] }
    const parsedData = parseFormData(buttonRef?.current?.values, previousFormData, isEditScreen, mid, jfsUserId)
    logEvent('btn_press', isEditScreen ? 'edit_user' : 'add_user')
    addEditUser(isEditScreen, parsedData)
  }

  const navigateUser = () => {
    setShowUserModel(false)
    
    if (Platform.OS === 'android')
    {
          navigation?.popTo(Routes.USER_MANAGEMENT.VIEW_USERS)
    }
    else
    {
          navigation?.goBack()
    }
  }
  const actionButton = (props: ActionButtonProps) => {
    //console.log('values', props)
    buttonRef.current = props
    setIsCurrentFormValid(props.isCurrentFormValid)
    return <></>
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ScrollView
        style={styles.listWrapper}
        contentContainerStyle={{ justifyContent: 'space-between', flexDirection: 'column' }}
        showsVerticalScrollIndicator={false}>
        <Form
          ref={formRef}
          container={({ children }) => <Box width={'100%'}>{children}</Box>}
          formData={getFormData()}
          actionButtons={actionButton}
          initialValues={{
            userName: editData?.user?.name ?? '',
            mobile: editData?.user?.mobileNo ?? '',
            email: editData?.user?.email ?? '',
            role: editData?.user?.department ?? '',
          }}
        />
        <Spacer size={40} direction="vertical" />
      </ScrollView>
      <ModBox bg={'WHITE'} pv={15} ph={25}>
        <RenderActionButtons
          buttonRef={buttonRef}
          isCurrentFormValid={isCurrentFormValid}
          isEditScreen={isEditScreen}
          addEmailEnabled={addEmailEnabled}
          mid={mid}
          jfsUserId={jfsUserId}
          previousFormData={{ ...editData?.user, accessRightsData: accessRightsData ?? [] }}
          screenName={Routes.USER_MANAGEMENT.VIEW_USERS}
          borderTopColor={'TRANSPARENT'}
          navigation={navigation}
          onSubmitPress={onSubmitPress}
          isLoading={addEditUserHandler?.state === 'pending'}
        />
      </ModBox>
      <ModelUserAdded
        title={isEditScreen ? 'User updated successfully' : 'User added successfully'}
        description={
          isEditScreen
            ? 'We have updatd user information for the mobile number'
            : 'User can now login to the Jio Business and access transactions with the permission you have provided'
        }
        show={showUserModel}
        data={buttonRef?.current?.values}
        onDismiss={() => setShowUserModel(false)}
        onPressDone={navigateUser}
      />
    </Box>
  )
}

const styles = {
  listWrapper: {
    backgroundColor: '#fff',
    padding: 25,
    paddingTop: 35,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    height: '100%',
    marginTop: 60,
    zIndex: 4,
    //overflow: 'auto',
  } as ViewProps,
}

export default AddUser
